import { render, staticRenderFns } from "./addTag.vue?vue&type=template&id=2a0d4c8d&"
import script from "./addTag.vue?vue&type=script&lang=js&"
export * from "./addTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports